import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class MyModalService {

  constructor() {}

  request: any;

  openModal(request): void {
    const modal = document.querySelector('.modal');
    this.request = request;

    if (modal) {
      modal.classList.add('show');
    };
  };

  closeModal(): void {
    const modal = document.querySelector('.modal');

    if (modal) {
      modal.classList.remove('show');
    };
  };

  openModalUsedDays(): void {
    const modal = document.querySelector('.modal-used-days');

    if (modal) {
      modal.classList.add('show-used-days');
    };
  };

  closeModalUsedDays(): void {
    const modal = document.querySelector('.modal-used-days');

    if (modal) {
      modal.classList.remove('show-used-days');
    };
  };

  getRequest() {
    return this.request;
  };
}